import * as Immutable from 'immutable'
import * as React from "react"

export const replaceWithJsx = (
  text: string,
  replacements: Immutable.Map<string, () => JSX.Element>,
  fb: (_:string) => JSX.Element = (s) => <>{s}</>
) : JSX.Element => (
  <>
    {
      text
        .split(new RegExp(/\%(.*?)\%/))
        .reduce<JSX.Element[]>((prev, current, i) => {
          return prev.concat(
            <React.Fragment key={i + 1}>
              {replacements.has(current) ? replacements.get(current)() : <React.Fragment key={i}>{fb(current)}</React.Fragment>}
            </React.Fragment>
          );
        }, [])
    }
  </>
);
